import { PhoneIcon } from '@heroicons/react/20/solid';

import { uniqueIdTransfer } from '@/apiCalls/uniqueIDTransferHelper';
import { EEventType } from '@/components/eventType';

export interface IProps {
    /**
     * The sentence above the button. It does not name the number: the button
     * underneath already does, and saying it twice reads as a mistake.
     */
    text: string;
    /** Verb on the button, e.g. "Call". */
    cta: string;
    /**
     * The partner's number, from config. Never written into this component or
     * the copy layer — a number in code goes stale the day the partner
     * changes theirs.
     */
    phone: string;
    baseId?: string;
}

export const testId = 'ContactPanel';

/**
 * The dark "talk to us instead" panel shown under a terminal outcome.
 *
 * Takes its ground from the partner's secondary colour rather than a fixed
 * near-black, so the panel themes itself if this is ever turned on for
 * partners other than CarExpert. It does assume that colour is dark: the
 * text on it is white and light grey.
 */
export function ContactPanel({
    text,
    cta,
    phone,
    baseId,
}: IProps): JSX.Element {
    function handleCall(): void {
        uniqueIdTransfer({
            eventType: EEventType.CLICK,
            applicationData: { id: `${baseId}-link-call` },
        });
    }

    return (
        <div
            data-testid={testId}
            className='bg-secondary rounded-2xl p-4 mt-3 _flex flex-col gap-3'
        >
            <p className='text-sm text-panelMuted'>{text}</p>
            {/* Calling is the only action on these screens, so it is reported
                the way a Button reports itself. */}
            <a
                href={`tel:${phone}`}
                id={`${baseId}-link-call`}
                onClick={handleCall}
                className='w-full _flex items-center justify-center gap-2 bg-primary hover:bg-primaryHover text-white font-bold rounded-full py-3 text-[15px]'
            >
                <PhoneIcon className='h-4 w-4' />
                {cta} {phone}
            </a>
        </div>
    );
}
